import {CustomerT} from "../../../types";
import React from "react";
import { formatMoney } from "../../../utils";

interface CustomerContactProps {
  customer: CustomerT;
}
export const OutstandingAmount: React.FC<CustomerContactProps> = ({customer}) => (
  <div className="md:ml-[1em] lg:ml-[0.2em] ml-[-1.7em] 540:ml-[4.5em] ">
    <p className="font-normal not-italic text-[ #000000]   xl:text-[16px] text-[12px] leading-6 tracking-wide mt-[33px] ml-[-1.5em] lg:ml-[-1em] xl:ml-0 md:ml-[-1.5em]">Amount outstanding </p>
    <span className="text-[#ef4444] lg;text-[25px] text-[18px] ml-[-1em] lg:ml-[-0.6em]  xl:ml-0">{formatMoney(customer?.totalOutstandings ? customer?.totalOutstandings : 0)}</span>
  </div>
);